import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

// Components
import MuiHeader from "../../components/MuiHeader";
import MuiLoader from "../../components/MuiLoader";
import ContentEditor from "../../components/ContentEditor";
import ContentPreview from "../../components/ContentPreview";

// Thunks
import { getpgeactivityskillThunk, getmasteractivitiydetailsThunk, createmasteractivitiesThunk, updatemasteractivitiesThunk } from "./PgeActivity.Thunk";
import { preferedlanguage_change, class_change, subject_change, skill_change } from "./PgeActivity.Slice";

// MUI
import { Avatar, Button, InputLabel, FormControl, Select, Box, Grid, Card, CardHeader, IconButton, Menu, MenuItem, useMediaQuery, useTheme } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import { orange } from "@mui/material/colors";

// toastify
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// swal
import Swal from "sweetalert2";

function PgeActivityPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // ------------ Grid gallery view -----------
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  // ---------------------------------------------

  // --------- options for dropdowns ---------
  const language_select_option_list = [
    { value: "od", text: "ଓଡିଆ" },
    { value: "en", text: "English" },
  ];
  const subject_select_option_list = [
    { value: "math", text: "Math" },
    { value: "english", text: "English" },
    { value: "odia", text: "Odia" },
    { value: "evs", text: "EVS" },
  ];
  const class_select_option_list = [
    { value: "1", text: "1" },
    { value: "2", text: "2" },
    { value: "3", text: "3" },
    { value: "4", text: "4" },
    { value: "5", text: "5" },
  ];
  // ------------------------------------------

  // -------------- Loader -----------------------
  const loading = useSelector((state) => state.PgeActivitySlice.loading);
  // ---------------------------------------------

  // -------------- Card-item vertical menu ---------------
  const ITEM_HEIGHT = 48;
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedSegment, setSelectedSegment] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const openVertMenu = Boolean(anchorEl);
  const handleVertMenuClick = (event, eachsegment, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
    setSelectedSegment(eachsegment);
  };
  const handleVertMenuClose = () => {
    setAnchorEl(null);
    setSelectedIndex(-1);
    setSelectedSegment({});
  };
  // ---------------------------------------------

  // --------------------- data --------------------------
  // const data = useSelector((state) => state.PgeActivitySlice.data);
  // //console.log("pge data--------------------------->", data);
  // const skill_select_option_list = useSelector(
  //   (state) => state.PgeActivitySlice.skills
  // );
  // -----------------------------------------------------

  // ---------------- navigate to skillset manager -------------
  const navigate_to = () => {
    navigate("/pgeskillsetmanager");
  };
  // ------------------------------------------------------------

  // ------------ dropdowns on change ----------------
  const preflanguage_select_onchange = (event) => {
    dispatch(preferedlanguage_change(event.target.value));
  };
  const subject_select_onchange = (event) => {
    dispatch(subject_change(event.target.value));
  };
  const class_select_onchange = (event) => {
    dispatch(class_change(event.target.value));
  };
  const skill_select_onchange = (event, value) => {
    dispatch(
      skill_change({
        skillsetid: event.target.value,
        skillsetname: value.props.children,
      })
    );
  };
  // -------------------------------------------------

  // ------------ Load data & skill ----------------
  const data = useSelector((state) => state.PgeActivitySlice.data);
  const skill_select_option_list = useSelector((state) => state.PgeActivitySlice.skills);

  const _id = data.length > 0 ? data[0]["_id"] : "";
  const existing_segments = data.length > 0 ? data[0]["segment"] : [];

  const program = "pge";
  const preferedlanguage = useSelector((state) => state.PgeActivitySlice.preferedlanguage);
  const clas = useSelector((state) => state.PgeActivitySlice.clas);
  const subject = useSelector((state) => state.PgeActivitySlice.subject);
  const skillsetid = useSelector((state) => state.PgeActivitySlice.skillsetid);
  const skillsetname = useSelector((state) => state.PgeActivitySlice.skillsetname);
  const disable_content_button = useSelector((state) => state.PgeActivitySlice.disable_content_button);

  useEffect(() => {
    const load_skills_list = () => {
      if (preferedlanguage.length > 0 && clas.length > 0 && subject.length > 0) {
        const params = { preferedlanguage, program, subject, clas };
        dispatch(getpgeactivityskillThunk(params));
      }
    };
    const load_data = () => {
      if (preferedlanguage.length > 0 && clas.length > 0 && subject.length > 0 && skillsetid.length > 0) {
        const params = { preferedlanguage, program, subject, clas, skillsetid };
        dispatch(getmasteractivitiydetailsThunk(params));
      }
    };
    load_skills_list();
    load_data();
  }, [dispatch, preferedlanguage, clas, subject, skillsetid, skillsetname]);
  // -----------------------------------------------

  // -------------- Preview -----------------------
  const [openPreview, setOpenPreview] = useState(false);
  const [previewContenttitle, setPreviewContenttitle] = useState("");
  const [previewContent, setPreviewContent] = useState("");

  const contentOnClick = (segment) => {
    setPreviewContenttitle(segment.displayname);
    setPreviewContent(segment.value);
    setOpenPreview(true);
  };

  const handleClosePreview = () => {
    setOpenPreview(false);
  };
  // ----------------------------------------------

  // ----------- create, update delete button click ----------
  const create_content_button_click = () => {
    setOperation("save");
    setContenttitle("");
    setContentduration(0);
    setContent("");
    setIndex(-1);
    setOpenEditor(true);
  };

  const update_content_button_click = (eachsegment, index) => {
    handleVertMenuClose();
    setOperation("update");
    setContenttitle(eachsegment.displayname);
    setContentduration(eachsegment.duration);
    setContent(eachsegment.value);
    setIndex(index);
    setOpenEditor(true);
  };

  const delete_content_button_click = (eachsegment, index) => {
    handleVertMenuClose();
    Swal.fire({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this record!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      //cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        const updated_segments = existing_segments.filter((e, i) => i != index);
        saveSegmentsIntoDatabase(updated_segments);
      }
    });
  };
  // ---------------------------------------------

  // -------------- Editor -----------------------
  const [openEditor, setOpenEditor] = useState(false);
  const [operation, setOperation] = useState("");
  const [contenttitle, setContenttitle] = useState("");
  const [contentduration, setContentduration] = useState(0);
  const [content, setContent] = useState("");
  const [index, setIndex] = useState(-1);

  const handleCloseEditor = () => {
    setOpenEditor(false);
  };

  const saveEditorContentData = (editor_data) => {
    if (editor_data.contenttitle.length <= 0) {
      toast.error("Enter a title for this content");
    } else if (parseInt(editor_data.contentduration) <= 0) {
      toast.error("Enter a valid expected duration for this content");
    } else if (isNaN(parseInt(editor_data.contentduration))) {
      toast.error("Entered duration is not a number");
    } else if (editor_data.content === "<div><br></div>") {
      toast.error("Enter some contents to save");
    } else if (editor_data.content.length <= 0) {
      toast.error("Enter some contents to save");
    } else {
      if (editor_data.operation === "save") {
        if (data.length <= 0) create1stContent(editor_data);
        else createNewContent(editor_data);
      } else if (editor_data.operation === "update") updateContent(editor_data); // change this function
    }
  };
  // ---------------------------------------------

  const create1stContent = (data) => {
    const body = {
      preferedlanguage,
      program,
      themeid: "",
      themename: "na",
      subject,
      class: clas,
      skillsetid: skillsetid,
      skillsetname: skillsetname,
      segment: [
        {
          id: new Date().getTime(),
          type: "text_content",
          displayname: data.contenttitle,
          duration: data.contentduration,
          s3name: null,
          filetype: null,
          s3_url: null,
          preview_url: null,
          value: data.content,
        },
      ],
      extraresources: [],
    };
    dispatch(createmasteractivitiesThunk(body))
      .then(handleCloseEditor())
      .then(() => {
        const params = { preferedlanguage, program, subject, clas, skillsetid };
        dispatch(getmasteractivitiydetailsThunk(params));
        toast.success("Changes made successfully");
      });
  };

  const createNewContent = (data) => {
    let newobj = {
      id: new Date().getTime(),
      type: "text_content",
      displayname: data.contenttitle,
      duration: data.contentduration,
      s3name: null,
      filetype: null,
      s3_url: null,
      preview_url: null,
      value: data.content,
    };
    const updated_segments = [...existing_segments, newobj];
    saveSegmentsIntoDatabase(updated_segments);
  };

  const updateContent = (data) => {
    const index = data.index;
    let selected_segment = existing_segments[index];
    let updatedObj = {
      id: selected_segment.id ? selected_segment.id : new Date().getTime(),
      type: selected_segment.type,
      displayname: data.contenttitle,
      duration: data.contentduration,
      s3name: null,
      filetype: null,
      s3_url: null,
      preview_url: null,
      value: data.content,
    };

    let updated_segments = existing_segments.map((obj, i) => {
      if (i === index) return updatedObj;
      return obj;
    });
    saveSegmentsIntoDatabase(updated_segments);
  };

  const saveSegmentsIntoDatabase = (updated_segments) => {
    const body = {
      segment: updated_segments,
    };
    dispatch(updatemasteractivitiesThunk({ _id, body }))
      .then(handleCloseEditor())
      .then(() => {
        const params = { preferedlanguage, program, subject, clas, skillsetid };
        dispatch(getmasteractivitiydetailsThunk(params));
        toast.success("Changes made successfully");
      });
  };
  // -------------------------------------------------

  return (
    <>
      <div>
        <MuiHeader header="PGE Activity" />
        <FormControl sx={{ m: 1, minWidth: 120 }} style={{ marginTop: 73 }} size="small">
          <InputLabel id="demo-select-small">Language</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={preferedlanguage} label="Language" onChange={preflanguage_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {language_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120 }} style={{ marginTop: 73 }} size="small">
          <InputLabel id="demo-select-small">Subject</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={subject} label="Subject" onChange={subject_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {subject_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120 }} style={{ marginTop: 73 }} size="small">
          <InputLabel id="demo-select-small">Class</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={clas} label="Class" onChange={class_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {class_select_option_list.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.text}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl sx={{ m: 1, minWidth: 120 }} style={{ marginTop: 73 }} size="small">
          <InputLabel id="demo-select-small">Skill</InputLabel>
          <Select labelId="demo-select-small" id="demo-select-small" value={skillsetid} label="Skill" onChange={skill_select_onchange}>
            <MenuItem value="">None</MenuItem>
            {skill_select_option_list.map((option) => (
              <MenuItem key={option.skillsetid} value={option.skillsetid}>
                {option.skillsetname}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Button onClick={navigate_to} variant="outlined" sx={{ m: 1, minWidth: 120 , marginTop: 0}} size="small">
          PGE Skillset Manager
        </Button>
      </div>

      {/* Show List */}
      <div>
        <Button onClick={create_content_button_click} variant="contained" disabled={disable_content_button}>
          Create New Content
        </Button>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={3}>
            {existing_segments.map((eachsegment, index) => (
              <Grid item xs={12} sm={isSmallScreen ? 12 : 6} md={4} key={index}>
                <Card sx={{ maxWidth: 345 }}>
                  <CardHeader
                    avatar={
                      <Avatar sx={{ bgcolor: orange[500] }}>
                        <AnalyticsIcon />
                      </Avatar>
                    }
                    action={
                      <>
                        <IconButton id={index + 1.1} onClick={(e) => handleVertMenuClick(e, eachsegment, index)} aria-controls={openVertMenu ? { index } : undefined} aria-expanded={openVertMenu ? "true" : undefined} aria-haspopup="true">
                          <MoreVertIcon />
                        </IconButton>
                      </>
                    }
                    title={
                      <div style={{ cursor: "pointer" }} onClick={() => contentOnClick(eachsegment)}>
                        <div>{eachsegment.displayname}</div>
                        <div style={{ color: "grey" }}>
                          {eachsegment.id ? eachsegment.id : ""}
                          <br />
                          {eachsegment.duration ? eachsegment.duration : 0} Minute(s)
                        </div>
                      </div>
                    }
                  />
                  {/* <CardMedia component="img" height="194" image={require("../../media/images/content.webp")} alt="content" />
                  <CardContent></CardContent> */}
                </Card>
              </Grid>
            ))}
            <Menu
              id={selectedIndex}
              anchorEl={anchorEl}
              open={openVertMenu}
              onClose={handleVertMenuClose}
              MenuListProps={{
                "aria-labelledby": "vert-button",
              }}
              PaperProps={{
                style: {
                  maxHeight: ITEM_HEIGHT * 4.5,
                  width: "20ch",
                },
              }}
            >
              <MenuItem onClick={() => update_content_button_click(selectedSegment, selectedIndex)}>Edit</MenuItem>
              <MenuItem onClick={() => delete_content_button_click(selectedSegment, selectedIndex)}>Delete</MenuItem>
            </Menu>
          </Grid>
        </Box>
      </div>

      {/* Editor */}
      <ContentEditor open={openEditor} operation={operation} contenttitle={contenttitle} setContenttitle={setContenttitle} contentduration={contentduration} setContentduration={setContentduration} content={content} setContent={setContent} index={index} onSave={saveEditorContentData} onClose={handleCloseEditor} />

      {/* Preview */}
      <ContentPreview open={openPreview} contenttitle={previewContenttitle} content={previewContent} onClose={handleClosePreview} />

      {/* Loader */}
      <MuiLoader open={loading} />

      {/* Toaster */}
      <ToastContainer />
    </>
  );
}

export default PgeActivityPage;
